import { ToastService } from './../../../_core/services/toast.service';
import { BrowserModule } from '@angular/platform-browser';
import { take } from 'rxjs/operators';
import { ScoreDelayService } from './score-delay.service';
import { CommonModule } from '@angular/common';
import { Match } from '../../../_shared/models/match.model';
import { IonicModule, PopoverController } from '@ionic/angular';
import { Component, Input, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-score-delay',
  templateUrl: './score-delay.component.html',
  styleUrls: ['./score-delay.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule]
})
export class ScoreDelayComponent implements OnInit {
  @Input() match: Match;

  private scoreDelayService = inject(ScoreDelayService);
  private popoverController = inject(PopoverController);
  private toastService = inject(ToastService);

  scoreDelay: number;

  ngOnInit() {    
    if (!this.match.scoreDelay) {
      this.match.scoreDelay = 3;
    }

    this.scoreDelay = this.match.scoreDelay;
  }

  updateScoreDelay() {    
    this.scoreDelayService
      .updateScoreDelay(this.match._id, this.scoreDelay)
      .pipe(take(1))
      .subscribe({
        next: async res => {
          this.match.scoreDelay = this.scoreDelay;
          this.toastService.presentToast(res.message);
          await this.close();
        }
      })
  }

  async close() {
    await this.popoverController.dismiss();
  }
}
